import { createEntryPoint } from '#packages/apilib';
import { BranchesManagerKey } from './publicApiKey';
import { BranchesManagerApi, initializeBranches } from './branchesManagerApi';
import { BranchesManagerScope } from './branchesManagerScope';

export const BranchesManagerEntryPoint = createEntryPoint({
  name: 'BranchesManager',
  Scope: BranchesManagerScope,
  publicApi({ contributeApi }) {
    contributeApi(BranchesManagerKey, BranchesManagerApi);
  },
  async initialize(scope: BranchesManagerScope) {
    const { editorAPI, editorCoreAPI } = scope;

    await Promise.all([
      new Promise((resolve) =>
        editorAPI.registerInitUserPrefsCallback(resolve),
      ),
      editorCoreAPI.hooks.stageIsReadyAndVisible.promise,
    ]);

    void initializeBranches(scope);
  },
});
